import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ToastErrorMessageComponent } from '../toast-error-message/toast-error-message.component';

@Component({
    selector: 'bfd-custom-datepicker',
    templateUrl: './bfd-datepicker.component.html',
    styleUrls: ['./bfd-datepicker.component.scss']
})
export class CustomDatepickerComponent {

    @ViewChild(ToastErrorMessageComponent, null)
    toast: ToastErrorMessageComponent;
    typeColorToast = "#ED6C6C";
    //this.toast.callModalMessage(null, err, null, null, null);

    @Output() rangeSelected = new EventEmitter<{ start: Date, end: Date }>();
    @Input() quickDays: number | null = null;
    @Input() startDate: Date | null = null;
    @Input() endDate: Date | null = null;
    @Input() allowFutureDates: boolean = false;
    @Input() emitQuickRangeOnInit = false;
    @Output() calendarOpenedChange = new EventEmitter<boolean>();

    monthBase: number = new Date().getMonth(); // exemplo: abril = 3
    yearBase: number = new Date().getFullYear(); // exemplo: 2025


    isOpen = false;
    initializedQuickRange = false;
    activeTab: 'Período' | 'Mês' | 'Ano' = 'Período';
    tabs = ['Período', 'Mês', 'Ano'];
    dateInput: string = '';
    selectedMonth: number | null = null;
    selectedYear: number | null = null;
    selectedQuickDays: number | null = null;
    quickOptions = [
        { label: '7 dias', days: 7 },
        { label: '15 dias', days: 15 },
        { label: '30 dias', days: 30 },
        { label: '45 dias', days: 45 }
    ];
    months = [
        { name: 'Janeiro', index: 0 }, { name: 'Fevereiro', index: 1 },
        { name: 'Março', index: 2 }, { name: 'Abril', index: 3 },
        { name: 'Maio', index: 4 }, { name: 'Junho', index: 5 },
        { name: 'Julho', index: 6 }, { name: 'Agosto', index: 7 },
        { name: 'Setembro', index: 8 }, { name: 'Outubro', index: 9 },
        { name: 'Novembro', index: 10 }, { name: 'Dezembro', index: 11 }
    ];

    years = [];

    ngOnChanges() {
        const today = new Date();
        this.years = this.allowFutureDates ? Array.from({ length: 12 }, (_, i) => today.getFullYear() + i).reverse() : Array.from({ length: 12 }, (_, i) => today.getFullYear() - i);
    
        if (this.quickDays && this.quickDays !== this.selectedQuickDays && !this.initializedQuickRange) {
            this.initializedQuickRange = true;
    
            if (this.emitQuickRangeOnInit) {
                this.selectQuick(this.quickDays);
            } else {
                // apenas configura, não emite
                const end = new Date();
                end.setHours(0, 0, 0, 0);
                const start = new Date(end);
                start.setDate(end.getDate() - (this.quickDays - 1));
                this.startDate = start;
                this.endDate = end;
                this.selectedQuickDays = this.quickDays;
                this.selectedMonth = null;
                this.selectedYear = null;
                this.dateInput = this.getFormattedRange();
            }
        }
    
        if (this.startDate && this.endDate) {
            this.selectedQuickDays = null;
            this.dateInput = this.getFormattedRange();
        }
    }
    

    onPrevMonth() {
        if (this.monthBase === 0) {
            this.monthBase = 11;
            this.yearBase--;
        } else {
            this.monthBase--;
        }
    }

    onNextMonth() {
        if (this.monthBase === 11) {
            this.monthBase = 0;
            this.yearBase++;
        } else {
            this.monthBase++;
        }
    }

    onPrevYear() {
        this.yearBase--;
    }

    onNextYear() {
        this.yearBase++;
    }

    toggleCalendar() {
        this.isOpen = !this.isOpen;
        this.calendarOpenedChange.emit(this.isOpen);

        // Reset da seleção para permitir novo clique manual
        if (this.isOpen && this.selectedQuickDays) {
            this.startDate = null;
            this.endDate = null;
            this.selectedQuickDays = null;
        }
    }

    setActiveTab(tab: 'Período' | 'Mês' | 'Ano') {
        this.activeTab = tab;
    }

    /*

    selectQuick(days: number) {
        const end = new Date();
        const start = new Date();
        start.setDate(end.getDate() - days + 1);
        this.startDate = start;
        this.endDate = end;
        this.selectedQuickDays = days;
        this.selectedMonth = null;
        this.selectedYear = null;

        console.log('----------------<SelectQuick>-------------')
        console.log(this.startDate);
        console.log(this.endDate);

        this.validateDates();
        this.emitRange();
    } */

    selectQuick(days: number) {
        console.log('[selectQuick] Dias selecionados:', days); // 👈 teste
        const end = new Date();
        end.setHours(0, 0, 0, 0);
        const start = new Date(end);
        start.setDate(end.getDate() - (days - 1));
        this.startDate = start;
        this.endDate = end;
        this.selectedQuickDays = days;
        this.selectedMonth = null;
        this.selectedYear = null;
        if (this.validateDates()) {
            this.emitRange();
            this.isOpen = false; 
            this.calendarOpenedChange.emit(this.isOpen);
        }
    }

    selectMonth(index: number): void {
        const today = new Date();
        const currentMonth = today.getMonth();
        const currentYear = today.getFullYear();
    
        if (this.selectedYear !== null) {
            if (!this.allowFutureDates &&
                (this.selectedYear > currentYear || (this.selectedYear === currentYear && index > currentMonth))) {
                this.toast.callModalMessage(null, "Não é permitido selecionar um mês futuro.", null, null, null);
                return;
            }
        }
    
        this.selectedMonth = index;
        this.checkAndEmitMonthYearRange();
    }
       
    
    selectYear(year: number): void {
        const today = new Date();
        if (!this.allowFutureDates && year > today.getFullYear()) {
            this.toast.callModalMessage(null, "Não é permitido selecionar um ano futuro.", null, null, null);
            return;
        }
    
        this.selectedYear = year;
        this.checkAndEmitMonthYearRange();
    }

    selectYearOnly(year: number) {
        const today = new Date();
        this.selectedYear = year;
    
        if (!this.allowFutureDates && year > today.getFullYear()) {
            this.toast.callModalMessage(null, "Não é permitido selecionar um ano futuro.", null, null, null);
            console.warn("Tentativa de seleção de ano futuro.");
            return;
        }
    
        this.startDate = new Date(year, 0, 1);
        this.endDate = (year === today.getFullYear()) ? today : new Date(year, 11, 31);
    
        if (this.validateDates()) {
            this.emitRange();
        }
    
        this.isOpen = false;
        this.calendarOpenedChange.emit(this.isOpen);
    }
    

    emitRange() {
        if (this.startDate && this.endDate) {
            this.rangeSelected.emit({ start: this.startDate, end: this.endDate });
        }
    }



    public validateDates(): boolean {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
    
        if (!this.startDate || !this.endDate) return false;
    
        const start = new Date(this.startDate);
        const end = new Date(this.endDate);
    
        if (start > end) {
            this.toast.callModalMessage(null, "A data inicial não pode ser maior que a data final.", null, null, null);
            return false;
        }
    
        const msPerDay = 1000 * 60 * 60 * 24;
        const diffDays = Math.round((end.getTime() - start.getTime()) / msPerDay);
    
        if (this.allowFutureDates) {
            if (start < today || end < today) {
                this.toast.callModalMessage(null, "Não é permitido selecionar datas passadas.", null, null, null);
                return false;
            }
    
            if (start >= today && end >= today && diffDays > 180) {
                this.toast.callModalMessage(null, "Período fora do alcance. O extrato é disponível para operações dentro do intervalo de 180 dias.", null, null, null);
                return false;
            }
    
        } else {
            const limitDate = new Date(today);
            limitDate.setDate(limitDate.getDate() + 1);
    
            if (start >= limitDate || end >= limitDate) {
                this.toast.callModalMessage(null, "Não é permitido selecionar datas futuras.", null, null, null);
                return false;
            }
    
            const limit = new Date(today);
            limit.setFullYear(limit.getFullYear() - 2);
        }
    
        return true;
    }
    


    onDateClick(date: Date) {
        if (!this.startDate || this.endDate) {
            this.startDate = date;
            this.endDate = null;
        } else {
            if (date < this.startDate) {
                this.endDate = this.startDate;
                this.startDate = date;
            } else {
                this.endDate = date;
            }

            if (this.startDate && this.endDate) {
                if (this.validateDates()) {
                    this.emitRange();
                }

                this.isOpen = false;
                this.calendarOpenedChange.emit(this.isOpen);
            }
        }
    }

    getFormattedRange(): string {
        const format = (d: Date) => {
            if (!(d instanceof Date) || isNaN(d.getTime())) return '';
            return `${('0' + d.getDate()).slice(-2)}/${('0' + (d.getMonth() + 1)).slice(-2)}/${d.getFullYear()}`;
        };

        if (this.startDate && this.endDate) {
            return `${format(this.startDate)} a ${format(this.endDate)}`;
        }
        return '';
    }



    isValidDate(dateStr: string): boolean {
        return /^\d{2}\/\d{2}\/\d{4}$/.test(dateStr);
    }

    onStartDateChange(value: string) {
        const parsed = this.stringToDate(value);
        if (parsed) {
            this.startDate = parsed;
            this.validateDates();
        } else {
            console.warn('Formato de data inicial inválido');
        }
    }

    onEndDateChange(value: string) {
        const parsed = this.stringToDate(value);
        if (parsed) {
            this.endDate = parsed;
            this.validateDates();
        } else {
            console.warn('Formato de data final inválido');
        }
    }

    formatDate(date: Date): string {
        const dd = ('0' + date.getDate()).slice(-2);
        const mm = ('0' + (date.getMonth() + 1)).slice(-2);
        const yyyy = date.getFullYear();
        return `${dd}/${mm}/${yyyy}`;
    }


    stringToDate(dateStr: string): Date | null {
        if (!dateStr) return null;

        if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
            const [day, month, year] = dateStr.split('/').map(Number);
            return new Date(year, month - 1, day);
        }

        if (/^\d{8}$/.test(dateStr)) {
            const day = parseInt(dateStr.slice(0, 2), 10);
            const month = parseInt(dateStr.slice(2, 4), 10) - 1;
            const year = parseInt(dateStr.slice(4, 8), 10);
            return new Date(year, month, day);
        }

        return null;
    }


    onInputBlur() {
        const [startStr, endStr] = this.dateInput.split(' a ');
    
        const startDate = this.stringToDate(startStr);
        const endDate = this.stringToDate(endStr);
    
        if (!startDate || !endDate) {
            console.warn('Formato de data inválido no input manual.');
            return;
        }
    
        this.startDate = startDate;
        this.endDate = endDate;
    
        if (this.validateDates()) {
            this.emitRange();
            this.isOpen = false;
            this.calendarOpenedChange.emit(this.isOpen);
        }
    }

    private checkAndEmitMonthYearRange(): void {
        if (this.selectedYear !== null && this.selectedMonth !== null) {
            const today = new Date();
            const currentMonth = today.getMonth();
            const currentYear = today.getFullYear();
    
            this.startDate = new Date(this.selectedYear, this.selectedMonth, 1);
    
            if (!this.allowFutureDates && this.selectedYear === currentYear && this.selectedMonth === currentMonth) {
                this.endDate = today;
            } else {
                this.endDate = new Date(this.selectedYear, this.selectedMonth + 1, 0);
            }
    
            if (this.validateDates()) {
                this.emitRange();
                this.isOpen = false;
                this.calendarOpenedChange.emit(false);
            }
        }
    }
    
}
